import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import axios from "axios";
import { apiRoot } from "../../index";

export default function WorkingTimeConfig() {
  const { userInfos } = useContext(UserContext);
  const [isFetching, setIsFetching] = useState(false);

  // Working time configuration state
  const [workingTimeConfig, setWorkingTimeConfig] = useState({
    beginsBeforePickup: 25,
    raisedHoursStart: "",
    raisedHoursEnd: "",
    mealHoursStart: "",
    mealHoursEnd: "",
    dinnerHoursStart: "",
    dinnerHoursEnd: "",
  });

  useEffect(() => {
    if (userInfos?.workingTimeConfig) {
      setWorkingTimeConfig(userInfos.workingTimeConfig);
    }
  }, [userInfos]);

  const handleWorkingTimeConfigChange = (e) => {
    const { name, value } = e.target;
    setWorkingTimeConfig((old) => ({
      ...old,
      [name]: value,
    }));
  };

  async function handleWorkingTimeConfigSubmit(e) {
    e.preventDefault();
    setIsFetching(true);

    try {
      await axios.post(
        apiRoot + "/api/v1/update-working-time-config",
        {
          workingTimeConfig,
        },
        {
          headers: {
            authorization: userInfos.jwt,
          },
        }
      );

      window.alert(
        "Configuration des heures de travail mise à jour avec succès"
      );
    } catch (e) {
      console.error(e);
      window.alert("Une erreur est survenue");
    }

    setIsFetching(false);
  }

  const buttonText = () =>
    isFetching === true ? (
      <button type="submit" className="btn btn-primary" disabled>
        Mise à jour...
      </button>
    ) : (
      <button type="submit" className="btn btn-primary">
        Mettre à jour
      </button>
    );

  return (
    <form onSubmit={handleWorkingTimeConfigSubmit} className="kt-form">
      <div className="kt-portlet__body">
        <div className="kt-section kt-section--first">
          <div className="kt-section__body">
            <div className="form-group row">
              <label className="col-lg-3 col-form-label">
                Commence avant l'heure de prise en charge (en minutes) :
              </label>
              <div className="col-lg-6">
                <input
                  type="number"
                  className="form-control"
                  name="beginsBeforePickup"
                  step="1"
                  value={workingTimeConfig.beginsBeforePickup || 0}
                  disabled={userInfos.createdBy}
                  onChange={handleWorkingTimeConfigChange}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-lg-3 col-form-label">
                Heures majorées - Début:
              </label>
              <div className="col-lg-6">
                <input
                  type="time"
                  className="form-control"
                  name="raisedHoursStart"
                  value={workingTimeConfig.raisedHoursStart || ""}
                  disabled={userInfos.createdBy}
                  onChange={handleWorkingTimeConfigChange}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-lg-3 col-form-label">
                Heures majorées - Fin:
              </label>
              <div className="col-lg-6">
                <input
                  type="time"
                  className="form-control"
                  name="raisedHoursEnd"
                  value={workingTimeConfig.raisedHoursEnd || ""}
                  disabled={userInfos.createdBy}
                  onChange={handleWorkingTimeConfigChange}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-lg-3 col-form-label">
                Heures de repas - Début:
              </label>
              <div className="col-lg-6">
                <input
                  type="time"
                  className="form-control"
                  name="mealHoursStart"
                  value={workingTimeConfig.mealHoursStart || ""}
                  disabled={userInfos.createdBy}
                  onChange={handleWorkingTimeConfigChange}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-lg-3 col-form-label">
                Heures de repas - Fin:
              </label>
              <div className="col-lg-6">
                <input
                  type="time"
                  className="form-control"
                  name="mealHoursEnd"
                  value={workingTimeConfig.mealHoursEnd || ""}
                  disabled={userInfos.createdBy}
                  onChange={handleWorkingTimeConfigChange}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-lg-3 col-form-label">
                Heures de dîner - Début:
              </label>
              <div className="col-lg-6">
                <input
                  type="time"
                  className="form-control"
                  name="dinnerHoursStart"
                  value={workingTimeConfig.dinnerHoursStart || ""}
                  disabled={userInfos.createdBy}
                  onChange={handleWorkingTimeConfigChange}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-lg-3 col-form-label">
                Heures de dîner - Fin:
              </label>
              <div className="col-lg-6">
                <input
                  type="time"
                  className="form-control"
                  name="dinnerHoursEnd"
                  value={workingTimeConfig.dinnerHoursEnd || ""}
                  disabled={userInfos.createdBy}
                  onChange={handleWorkingTimeConfigChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="kt-portlet__foot">
        {!userInfos.createdBy && (
          <div className="kt-form__actions">{buttonText()}</div>
        )}
      </div>
    </form>
  );
}
